import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { FeaturePsService } from '@h5s/feature-ps';
import { map } from 'rxjs';

/**
 * Angular route guard (`featurePsGuard`) che garantisce la presenza dei parametri di query `profile` e `date` nell'URL.
 *
 * - Se non abbiamo profili di pubblica sicurezza visualizza dialog e non permette l'accesso alla pagina
 * - Se entrambi i parametri sono già presenti, permette l'accesso alla rotta.
 * - Se uno dei parametri è assente, lo imposta con un valore di default (definito in `PS_FILTERS_DEFAULTS`) e reindirizza l'utente alla stessa pagina con i parametri valorizzati.
 * - I parametri vengono serializzati tramite i parser definiti in `psFiltersParser`.
 * - Questo comportamento assicura che la pagina non venga mai caricata con parametri `profile` o `date` non definiti.
 *
 * @param route Informazioni sulla rotta attivata, inclusi i parametri di query.
 * @param state Stato corrente della navigazione.
 * @returns `true` se i parametri sono già presenti, altrimenti un `UrlTree` per reindirizzare con i parametri di default.
 */

export const featurePsGuard: CanActivateFn = (route) => {
  const featurePsService = inject(FeaturePsService);

  return featurePsService.getOwnerPublicSecurityRecord().pipe(
    map((profileOpts) => {
      return featurePsService.validatePsForNavigation(profileOpts, route);
    }),
  );
};
